import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';
import { G, Mask, Rect } from 'react-native-svg';

export const TrashIcon = (props: SvgProps) => {
  return (
    <Svg width={props.size || 28} height={props.size || 28} viewBox="0 0 28 28" fill="none">
      <Rect
        x="0.583333"
        y="0.583333"
        width="26.8333"
        height="26.8333"
        rx="13.4167"
        stroke={props.fill || '#502314'}
        strokeWidth="1.16667"
      />
      <Mask
        id="mask0_15717_17934"
        // @ts-ignore
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="18"
        height="18"
      >
        <Rect x="5.83337" y="5.83334" width="16.3333" height="16.3333" fill="#D9D9D9" />
      </Mask>
      <G mask="url(#mask0_15717_17934)">
        <SvgPath
          fill={props.fill || '#502314'}
          d="M10.5972 20.125C10.2229 20.125 9.90247 19.9917 9.63592 19.7252C9.36937 19.4586 9.2361 19.1382 9.2361 18.7639V9.91667H8.55554V8.55556H11.9583V7.875H16.0417V8.55556H19.4444V9.91667H18.7639V18.7639C18.7639 19.1382 18.6306 19.4586 18.364 19.7252C18.0975 19.9917 17.7771 20.125 17.4028 20.125H10.5972ZM17.4028 9.91667H10.5972V18.7639H17.4028V9.91667ZM11.9583 17.4028H13.3194V11.2778H11.9583V17.4028ZM14.6805 17.4028H16.0417V11.2778H14.6805V17.4028Z"
        />
      </G>
    </Svg>
  );
};
